<template>
  <div>

        <b-modal id="modal-sm" size="md" title="Manage Patient Notes" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
            <div slot="default">
                <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
                <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
            </div> 
            <div slot="modal-footer" class="w-100">
                <p class="float-left" variant="primary"></p>
                <b-button variant="primary"  size="md"  class="float-right"  @click="PatientNoteExit"> Close </b-button>
            </div>
        </b-modal>

            <div class="form-group row my-1">
                <label for="HSN" class="col-sm-4 label-small my-0">HSN:</label>
                 <div class="col-sm-4 my-0">
                    <input id="HSN" v-model="hsn" :disabled="true" type="text" class="mb-0 form-control form-control-xs">
                </div>

            </div>

            <div class="form-group row my-1">
                <label for="ServiceType" class="col-sm-4 label-small my-0">Service Type:</label>
                 <div class="col-sm-4 my-0">
                    <input id="ServiceType" v-model="ServiceName" :disabled="true" type="text"  class="mb-0 form-control form-control-xs">
                </div>

            </div>

            <div class="form-group row my-1">
                <label for="PatientNote" class="col-sm-4 label-small my-0">Patient Note (Maximum 4000 characters):</label>
                 <div class="col-xl-8 my-0">
                    <textarea id="PatientNote" rows="8" cols="45"  maxlength="4000"  v-model="Note" type="text"  placeholder="Patient Note"  class="mb-0  text-area-xs"></textarea>
                </div>
                
                <div  class="col-xl-12 " v-show="$v.Note.$error">
                    <div class="row">
                        <div class="col-xl-4"></div>
                        <div class="col-xl-8 float-right">
                            <small class="my-0 sml-red" v-if="!$v.Note.required">Patient note is required</small>
                        </div>
                    </div> 
                 </div>

            </div>

       <hr>
        <div class="row" >
            <div class="col-sm-6" >
                    <button v-bind:disabled="disableSave" v-on:click="SavePopup" type="button" class="btn BtnSave  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
            </div>
            <div class="col-sm-6">
                <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
            </div>
        </div> 
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'
import { required} from 'vuelidate/lib/validators'
export default {
        props:{
        UserData:'',
        mode:''
    },
      data: function (){
          return{
           succeeded:true,
           EditMode:'',
           hsn:'',
           showModal:false,
           Msg:'',
           saveIcon:'fas fa-plus',
           btnName: 'Add Patient Note',
           ServiceName:'',
           Note:'',
           ServiceID:'',
           NoteID:'',
           disableSave:false
           }
      },
 created: function(){
    this.EditMode = this.mode;
    this.hsn = this.UserData.hsn;
    this.ServiceID = this.UserData.serviceid
    this.Note = this.UserData.notes==undefined?"":this.UserData.notes;
    this.NoteID=this.NoteID ==undefined?"":this.UserData.noteid;

      if(this.EditMode  == 'Edit')
      {
          this.btnName = 'Edit Patient Note';
          this.saveIcon = 'far fa-edit'; 
      } 
  
    var vm = this;
    var params = new URLSearchParams();
    
    params.append('ServiceID', vm.ServiceID);
        axios.get('SaskHealthApi/Codes/GetServicename?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
        .then(function (response) {
            vm.ServiceName = response.data.name;
            })
        .catch(function (er) {

            console.log(er)
            
            });

 
 },
    methods:{
        PatientNoteExit: function(){
        this.showModal=false;
          if(this.succeeded){
           this.$emit('PatientNoteExit');
        }   

    },
    SavePopup: function(){
        this.$v.$touch();
         if (!this.$v.$invalid){
                this.disableSave = true;
                var vm = this;
                 var params = {
                "_": Date.now(), 
                "HSN": vm.hsn,
                "ServiceID" : vm.ServiceID,
                "Notes":vm.Note,
                "Mode":vm.EditMode=="Add"?'A':'E',
                "NoteId":vm.NoteID
                 };
               
                  var url = "SaskHealthApi/Claims/PostUpdateNotes/"

                  axios({
                    method: 'post',
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
                    data: params
                    }).then(function (response) {
                        console.log(response)
                                vm.succeeded = true;
                                 vm.Msg= "HSN " + vm.hsn + ": Note saved successfully. ";                        
                                vm.showModal=true;
                })
                .catch(function (er) {
                     vm.disableSave = false;
                     vm.succeeded = false;
                     console.log(er);
                    vm.Msg="Warning: Save UnSuccessfully For HSN " +  vm.hsn+ ".";  
                     vm.showModal=true;
               
                }).then(function () {

                }); 
         }
    },
    ClosePopup: function(){
        this.$root.$emit('bv::hide::modal', 'editModal', '#btnShow') 
        this.$v.$reset();
    }

},
 validations(){
    return {
        Note:{
            required
        }
    }
}
}
</script>

<style>

</style>
